import React from 'react';
import { Link } from "react-router-dom";
import * as util from "../../other/util.js";
import { GameData } from "../../share/game-data.js";
import { PlanetLink } from "../../other/util.js";

// A list with all outstanding events for the player
export default class EventListView extends React.Component {
    render() {
        let events = this.props.events;

        return (
            <div>
                <div style={{ textAlign: "center" }}>
                    {events.length === 0 ? <span className="boring-info-text">No outstanding events. Awaiting your orders, Sir!</span> : <div />}
                </div>
                <table className="generic-list">
                    <tbody>
                        {events.map((event, idx) => this.renderEvent(event, idx))}
                    </tbody>
                </table>
            </div>
        );
    }

    renderEvent(event, idx) {
        switch (event.type) {
            case "CONSTRUCTION_EVENT":
                return this.renderBuildingEvent(event, idx);
            case "RESEARCH_EVENT":
                return this.renderResearchEvent(event, idx);
            case "SHIP_DESIGN_EVENT":
                return this.renderShipDesignEvent(event, idx);
            case "SHIP_CONSTRUCTION_EVENT":
                return this.renderShipConstructionEvent(event, idx);
            case "FLEET_EVENT":
                return this.renderFleetEvent(event, idx);
            case "COMBAT_EVENT":
                return this.renderCombatEvent(event, idx);
            default:
                return this.renderUnknownEvent(event, idx);
        }
    }

    renderBuildingEvent(event, idx) {
        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    <util.PlanetLink planet={event.planet} />
                </td>
                <td style={{ width: "80%" }}>
                    {GameData.BUILDING_BY_ID[event.building_id].ui_name} ({event.level})
                </td>
            </tr>
        );
    }

    renderResearchEvent(event, idx) {
        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    Research
                </td>
                <td style={{ width: "80%" }}>
                    {GameData.TECHNOLOGY_BY_ID[event.technology_id].ui_name} ({event.level})
                </td>
            </tr>
        );
    }

    renderShipDesignEvent(event, idx) {
        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    <util.PlanetLink planet={event.planet} />
                </td>
                <td style={{ width: "80%" }}>
                    Ship design: <Link className="link-button" to={"/game/ship-design/" + event.ship_design.id}>{event.ship_design.name}</Link>
                </td>
            </tr>
        );
    }

    renderShipConstructionEvent(event, idx) {
        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    <util.PlanetLink planet={event.planet} />
                </td>
                <td style={{ width: "80%" }}>
                    Ship construction: <Link className="link-button" to={"/game/ship-design/" + event.ship_design_id}>{event.ship_design_name}</Link>
                </td>
            </tr>
        );
    }

    renderFleetEvent(event, idx) {
        let text = this.getFleetStepHtml(event);

        let enemy_text = null;
        let fleet_name = null;
        if (event.fleet_owner_id !== util.getGPS().player_id) {
            enemy_text = (<span> [<util.PlayerLink playerId={event.fleet_owner_id} playerName={event.fleet_owner_name} />]</span>);
            fleet_name = (<span style={{ color: "red" }}>Enemy</span>)
        } else {
            fleet_name = (<span><util.FleetLink fleetId={event.fleet_id} fleetName={event.fleet_name} /></span>);
        }

        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    <span>{fleet_name}</span>
                </td>
                <td style={{ width: "80%" }}>
                    <span>{text}{enemy_text}</span>
                </td>
            </tr>
        );
    }

    getFleetStepHtml(event) {
        const location = event.location;
        const origin = event.origin;
        const step = event.state;

        const is_location_foreign_planet = location && location.owner_id !== util.getGPS().player_id;
        const is_origin_foreign_planet = origin && origin.owner_id !== util.getGPS().player_id;

        switch (step) {
            case "LOAD":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Transshipping on </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "LAUNCH":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Launching from </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "LAND":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Landing on </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "MOVE":
                return (
                    <div style={{ display: "inline" }}>
                        <PlanetLink planet={event.origin} showOwner={is_origin_foreign_planet} />
                        <span> &#8594; </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "STATION":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Stationing on </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "RAID":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Raiding on </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "REPAIR":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Repairing on </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            case "COLONIZE":
                return (
                    <div style={{ display: "inline" }}>
                        <span>Colonizing </span>
                        <PlanetLink planet={location} showOwner={is_location_foreign_planet} />
                    </div>);
            default:
                return "UNKNOWN STEP: '" + step + "'";
        }
    }

    renderCombatEvent(event, idx) {
        return (
            <tr key={idx}>
                <td style={{ width: "20%", paddingRight: "12px", textAlign: "end" }}>
                    <util.Timer date={event.finished} />
                </td>
                <td>
                    <util.FleetLink fleetId={event.fleet_id} fleetName={event.fleet_name} />
                </td>
                <td style={{ width: "80%" }}>
                    <span>Fighting on </span>
                    <PlanetLink planet={event.location} />
                </td>
            </tr>
        );
    }

    renderUnknownEvent(event, idx) {
        return (
            <tr key={idx}>
                <td>
                    <util.Timer date={event.finished} />
                </td>
                <td>{event.type}</td>
            </tr>
        );
    }
}